/**
 * @Description: 全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
 * @author fen
 * @date 2023/5/23
*/

import Vue from "vue";
Vue.directive('show-img', async function (el, binding) {
  let imgURL = binding.value;
  if (imgURL) {
    let exist = await imageIsExist(imgURL);
    if (exist) {
      el.setAttribute('src', imgURL);
    }
  }
})

/**
 * 检测图片是否存在
 * @param url
 */
let imageIsExist = function(url) {
  return new Promise((resolve) => {
    let img = new Image();
    img.onload = function () {
      if (this.complete){
        resolve(true);
        img = null;
      }
    }
    img.onerror = function () {
      resolve(false);
      img = null;
    }
    img.src = url;
  })
}

/**
 * @Description: 模拟v-html
 * @date 2023/7/25
 */
Vue.directive('art-html', function (el, binding) {
  el.innerHTML = binding.value;
});




// WEBPACK FOOTER //
// ./src/global/directive.js